import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { CardSectionNew } from '../CardSectionNew';

export interface IPromos {
  Promos?: React.ComponentType;
  Banner: React.ComponentType;
  newbuildingName: string;
}

export const NewbuildingPromos = (props: React.PropsWithChildren<IPromos>) => {
  const { Promos, Banner, newbuildingName } = props;

  return (
    <CardSectionNew>
      <div className={styles['title']}>
        <UIHeading1 as="h2">Акции в ЖК {newbuildingName}</UIHeading1>
      </div>
      <Banner />
      {Promos && <Promos />}
    </CardSectionNew>
  );
};
